import { memo, useMemo } from "react";
import Featurelist from "./FeatureProductlist/Featurelist";

function Features({ data = [] }) {
	const featuredProducts = useMemo(
		() => (Array.isArray(data) ? data.slice(0, 12) : []),
		[data]
	);

	return (
		<section className="perf-defer-section overflow-x-hidden">
			<div className="mb-10 overflow-hidden text-center">
				<h2 className="font-lora text-4xl font-semibold md:text-5xl">
					Redefine Your Everyday Look
				</h2>
			</div>

			{featuredProducts.length > 0 ? (
				<ul className="mb-16 mt-20 grid grid-cols-1 gap-4 overflow-x-hidden px-4 sm:grid-cols-2 md:grid-cols-3 md:px-10 lg:px-16 xl:grid-cols-4">
					{featuredProducts.map((item, index) => (
						<Featurelist
							key={item._id || item.id || item.style || index}
							data={item}
						/>
					))}
				</ul>
			) : (
				<div className="py-10 text-center">
					<p className="text-gray-500">No featured products available</p>
				</div>
			)}
		</section>
	);
}

export default memo(Features);
